import { render, staticRenderFns } from "./ServicesNav.vue?vue&type=template&id=52637027&scoped=true"
import script from "./ServicesNav.vue?vue&type=script&lang=ts"
export * from "./ServicesNav.vue?vue&type=script&lang=ts"
import style0 from "./ServicesNav.vue?vue&type=style&index=0&id=52637027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52637027",
  null
  
)

export default component.exports